<div class="header-container">
  <h1 class="header-title">Test Push Notifications</h1>
</div>
<div class="content">
  <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="send()" class="push-form">
    <nz-form-item>
      <nz-form-label nzRequired>Recipient</nz-form-label>
      <nz-form-control nzErrorTip="Please select a recipient">
        <nz-select formControlName="subscription" nzShowSearch
                   [nzPlaceHolder]="loading ? 'Loading recipients...' : 'Select recipient'"
                   [nzLoading]="loading"
                   [nzNotFoundContent]="loading ? loadingRecipients : undefined"
                   [nzCustomTemplate]="selectedSubscription">
          @for (s of subscriptions; track s.endpoint) {
            <nz-option nzCustomContent [nzValue]="s" [nzLabel]="label(s)">
              {{ label(s) }} · {{ s.last_accessed | yomaDateFormat:'dd.MM.yyyy' }}
            </nz-option>
          }
        </nz-select>
        <ng-template #loadingRecipients>
          <nz-spin nzSimple nzSize="small"></nz-spin> Loading recipients...
        </ng-template>
        <ng-template #selectedSubscription let-selected>
          {{ selected.nzLabel }} · {{ selected.nzValue.last_accessed | yomaDateFormat:'dd.MM.yyyy HH:mm' }}
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzRequired>Title</nz-form-label>
      <nz-form-control nzErrorTip="Please enter a title">
        <input nz-input formControlName="title" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzRequired>Text</nz-form-label>
      <nz-form-control nzErrorTip="Please enter a text">
        <textarea nz-input rows="4" formControlName="message"></textarea>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label>Link</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="link" placeholder="/find/123" />
      </nz-form-control>
    </nz-form-item>
    <button nz-button nzType="primary" [nzLoading]="sending" [disabled]="form.invalid">Send</button>
  </form>
</div>
